import { IconType } from '@teamworksdev/icons';
import { cn } from '../../../components/utils';

export function ContextMenuItemIcon({
  IconPath,
  className: classNames,
}: {
  IconPath: IconType;
  className?: string;
}) {
  return <IconPath className={cn('mr-2 h-5 w-4', classNames)} />;
}
